import { render, staticRenderFns } from "./AlertRuleView.vue?vue&type=template&id=3e021b34&lang=pug&"
import script from "./AlertRuleView.vue?vue&type=script&lang=ts&"
export * from "./AlertRuleView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports